export enum CustomerExperienceCategoryBaseStatusEnum {
    OPEN = '7b8872d2-7649-4002-b1bb-1760a530aee2',
    ASSIGNED = '70c7a568-5ef9-4b57-9d78-a91207a37f60',
    IN_PROGRESS = '26b77f64-6bd8-4502-96b6-fd7f455f61bb',
    SOLVED = 'a6cc3167-b39f-4054-9a0a-d5bc723fe8ab'
}
